import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    TableFooter,
    TablePagination,
} from '@mui/material';
import { Edit, Delete, Send } from '@mui/icons-material';
import { Communication } from "../../../data/Communication";

interface Props {
    communications: Communication[];
    onEdit: (type: Communication) => void;
    onDeleteClick: (type: Communication) => void;
    onSendEmail: (type: Communication) => void;
    onViewDetails?: (type: Communication) => void;
    page: number;
    rowsPerPage: number;
    onPageChange: (event: unknown, newPage: number) => void;
    onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const formatTimestamp = (isoString: string | null | undefined): string => {
    if (!isoString) return "N/A";
    const date = new Date(isoString);
    return date.toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZoneName: "short",
    });
};

const CommunicationList: React.FC<Props> = ({
                                                communications,
                                                onEdit,
                                                onDeleteClick,
                                                onSendEmail,
                                                onViewDetails,
                                                page,
                                                rowsPerPage,
                                                onPageChange,
                                                onRowsPerPageChange,
                                            }) => {
    const displayedRows = communications.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    return (
        <TableContainer sx={{ border: "1px solid #ddd", borderRadius: "8px" }}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell><b>Title</b></TableCell>
                        <TableCell><b>Status</b></TableCell>
                        <TableCell><b>Composed By</b></TableCell>
                        <TableCell><b>Composed Time Stamp</b></TableCell>
                        <TableCell><b>Reviewed By</b></TableCell>
                        <TableCell><b>Reviewed Time Stamp</b></TableCell>
                        <TableCell><b>Send Date</b></TableCell>
                        <TableCell><b>Actions</b></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {displayedRows.map((type) => (
                        <TableRow
                            key={type.communicationId}
                            onClick={() => onViewDetails && onViewDetails(type)}
                            sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}
                        >
                            <TableCell>{type.title}</TableCell>
                            <TableCell>{type.status}</TableCell>
                            <TableCell>{type.composedBy}</TableCell>
                            <TableCell>{formatTimestamp(type.composedTimeStamp)}</TableCell>
                            <TableCell>{type.reviewedBy}</TableCell>
                            <TableCell>{formatTimestamp(type.reviewedTimeStamp)}</TableCell>

                            <TableCell>
                                {type.sendDate ? (
                                    <div>
                                        <span style={{ fontWeight: 500, fontSize: "0.95em", color: "#000" }}>
                                                            {formatTimestamp(type.sendDate)}
                                        </span>
                                        <br />
                                        <span style={{ fontSize: "0.75em", color: "#000" }}>
                                            {new Date(type.sendDate).toLocaleDateString("en-US", { weekday: "long" })}
                                        </span>
                                    </div>
                                ) : (
                                    "N/A"
                                )}
                            </TableCell>


                            <TableCell onClick={(e) => e.stopPropagation()}>
                                <IconButton onClick={(e) => { e.stopPropagation(); onEdit(type); }}>
                                    <Edit />
                                </IconButton>
                                <IconButton onClick={(e) => { e.stopPropagation(); onDeleteClick(type); }}>
                                    <Delete />
                                </IconButton>
                                <IconButton onClick={(e) => { e.stopPropagation(); onSendEmail(type); }}>
                                    <Send />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            count={communications.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={onPageChange}
                            onRowsPerPageChange={onRowsPerPageChange}
                        />
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    );
};

export default CommunicationList;
